<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 수행평가 대상 -->
    <div class="mt-28px">
          <h5 class="mb-4"><i class="dot"></i> 수행평가 대상</h5>
      <div class="writeGridContainer">
        <div>
          <div>부서(업체)명</div>
          <p v-if="isPrint" class="print-input">{{ form.field_name }}</p>
          <company-selector v-else v-model="form.inputA_1" :fieldId="form.stdInfo.field_id" :field-name="form.field_name" :readonly="board.readonly || !form.stdInfo.field_id" @select="onSelectFieldSelector" />
        </div>
        <div>
          <div>피평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_6 }}</p>
          <date-selector s v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    청소(미화)-->
    <table-inspect-performance-evaluation
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="업무 수행 여부"
      v-model="form.inspectList"
      :is-header-column1="false"
      :is-note="true"
      :is-note2="true"
      table-header-column2="관계법령"
      table-header-title="평가항목"
      table-header-yes="적정"
      table-header-no="미흡"
      table-header-na="해당없음"
      table-header-note="향후 개선계획"
      table-header-note2="비고"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import TableInspect from "@/components/TableInspect";
import TableInspectPerformanceEvaluation from "@/components/TableInspectPerformanceEvaluation.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    SignField,
    CompanySelector,
    PhotoUploadGridModule,
    TableInspectPerformanceEvaluation,
    TableInspect,
    DateSelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        field_name: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",

        inspectList: [
          {
            id: 1,
            col2: "중처법시행령 제4조",
            label: "1. 사업장의 산업재해 예방계획의 수립에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 2,
            col2: "산업법 제25조",
            label: "2. 안전보건관리규정의 작성 및 변경에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },

          {
            id: 3,
            col2: "산안법 제29조",
            label: "3. 안전보건교육에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 4,
            col2: "산안법 제125조",
            label: "4. 작업환경측정 등 작업환경의 점검 및 개선에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 5,
            col2: "산안법 제132조",
            label: "5. 근로자의 건강진단 등 건강관리에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 6,
            col2: "산안법 제57조",
            label: "6. 산업재해의 원인 조사 및 재발 방지대책 수립에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 7,
            col2: "산안법 제4조",
            label: "7. 산업재해에 관한 통계의 기록 및 유지에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 8,
            col2: "산안법 제15조",
            label: "8. 안전장치 및 보호구 구입 시 적격품 여부 확인에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 9,
            col2: "산안법 제36조",
            label: "9. 위험성평가 실시에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },
          {
            id: 10,
            col2: "산안법 제129조",
            label: "10. 근로자의 위험 또는 건강장해의 방지에 관한 사항",
            is_checked: "",
            note: "",
            note2: "",
            title: "",
          },

        ],
        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },
      },
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.field_name = value.com_name;
      this.$emit("selectField", value);
    },
    updateListCheck(indexRows, text) {
      console.log("updateListCheck (indexRows, text)", indexRows, text);
      this.form.inspectList[indexRows].is_checked = text;
    },
    updateListNote(indexRows, text) {
      this.form.inspectList[indexRows].note = text;
    },
    selectField() {
      this.form.inputA_1 = "";
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
